import {
    FETCH_TRANSFER_WITH_PERCENTAGE,
    LIST_TRANSFER_WITH_PERCENTAGE, LIST_TRANSFER_WITH_PERCENTAGE_SC
} from "./types";

const init = {
    isLoading: false,
    data: null,
    dataSc:null,
    filter: {}
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_TRANSFER_WITH_PERCENTAGE:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_TRANSFER_WITH_PERCENTAGE:
            return {
                ...state,
                isLoading: false,
                data: payload.data
            };

        case LIST_TRANSFER_WITH_PERCENTAGE_SC:
            return {
                ...state,
                isLoading: false,
                dataSc: payload.data
            };
        default:
            return state

    }
}